// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__19pYC","content":"styles_content__3256I","checkbox":"styles_checkbox__1IT6a","checkboxLabel":"styles_checkboxLabel__1gPDM"};